import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: opacity 0.3s ease;
`;

const PopupContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  transition: transform 0.3s ease;
  transform: ${props => props.show ? 'scale(1)' : 'scale(0.9)'};
`;

const Title = styled.h3`
  margin-top: 0;
  color: #333;
  font-size: 1.2rem;
`;

const Message = styled.p`
  margin: 15px 0;
  color: #666;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
  border: none;

  &:focus {
    outline: none;
  }
`;

const ConfirmButton = styled(Button)`
  background-color: ${props => props.danger ? '#dc3545' : '#4CAF50'};
  color: white;
  
  &:hover {
    background-color: ${props => props.danger ? '#c82333' : '#3d8b3d'};
  }
`;

const CancelButton = styled(Button)`
  background-color: #f8f9fa;
  color: #212529;
  border: 1px solid #dee2e6;
  
  &:hover {
    background-color: #e2e6ea;
  }
`;

/**
 * PopupMessage Component
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to display the popup
 * @param {string} props.title - Title of the popup
 * @param {string} props.message - Message to display
 * @param {string} props.confirmText - Text for the confirm button
 * @param {string} props.cancelText - Text for the cancel button
 * @param {function} props.onConfirm - Function to call when confirm is clicked
 * @param {function} props.onCancel - Function to call when cancel is clicked
 * @param {boolean} props.isDanger - If true, confirm button will be red
 */
const PopupMessage = ({ 
  show, 
  title, 
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel', 
  onConfirm, 
  onCancel,
  isDanger = false 
}) => {
  if (!show) return null;

  return (
    <Overlay onClick={onCancel}>
      <PopupContainer show={show} onClick={e => e.stopPropagation()}>
        {title && <Title>{title}</Title>}
        <Message>{message}</Message>
        <ButtonContainer>
          <CancelButton onClick={onCancel}>
            {cancelText}
          </CancelButton>
          <ConfirmButton danger={isDanger} onClick={onConfirm}>
            {confirmText}
          </ConfirmButton>
        </ButtonContainer>
      </PopupContainer>
    </Overlay>
  );
};

export default PopupMessage;